import React from "react";
import PropTypes from "prop-types";
import PreviousEventsBlock from "components/Contentful/PreviousEventsBlock";
import UpcomingEventsBlock from "components/Contentful/UpcomingEventsBlock";
import GenericHeader from "components/Contentful/GenericHeaderBlock";
import CollapsibleBlock from "components/Contentful/CollapsibleBlock";
import ImageTextBlock from "components/Contentful/ImageTextBlock";
import ProviderEmailSignupBlock from "components/Contentful/ProviderEmailSignupBlock";
import CtaBasicBlock from "components/Contentful/CtaBasicBlock";
import HeroBlock from "components/Contentful/HeroBlock";
import LocationPageImageTextBlock from "components/Contentful/LocationPageImageTextBlock";
import FeaturedBusinessBlock from "components/Contentful/FeaturedBusinessBlock";
import GenericCTA from "components/Contentful/GenericCtaBlock";
import GraphicList from "components/Contentful/GraphicListBlock";
import LocationPageSearchBlock from "components/Contentful/LocationPageSearchBlock";

function DynamicBlockContainer({
  blockType,
  cityName,
  coordinates,
  fields,
  service,
}) {
  return (
    (blockType === "eventsIndexHeaderBlock" && (
      <GenericHeader fields={fields} />
    )) ||
    (blockType === "upcomingEventsBlock" && (
      <UpcomingEventsBlock fields={fields} />
    )) ||
    (blockType === "previousEventsBlock" && (
      <PreviousEventsBlock fields={fields} />
    )) ||
    (blockType === "collapsibleBlock" && (
      <CollapsibleBlock blockData={fields} />
    )) ||
    (blockType === "imageTextBlock" && <ImageTextBlock blockData={fields} />) ||
    (blockType === "providerEmailSignupBlock" && (
      <ProviderEmailSignupBlock fields={fields} />
    )) ||
    (blockType === "ctaBasicBlock" && <CtaBasicBlock blockData={fields} />) ||
    (blockType === "heroBlock" && <HeroBlock blockData={fields} />) ||
    (blockType === "locationPageImageTextBlock" && (
      <LocationPageImageTextBlock blockData={fields} />
    )) ||
    (blockType === "featuredSearch" && (
      <FeaturedBusinessBlock
        blockData={fields}
        cityName={cityName}
        coordinates={coordinates}
        service={service}
      />
    )) ||
    (blockType === "locationPageGenericCtaBlock" && (
      <GenericCTA blockData={fields} cityName={cityName} service={service} />
    )) ||
    (blockType === "graphicList" && (
      <GraphicList blockData={fields} cityName={cityName} />
    )) ||
    (blockType === "landing_page" && (
      <LocationPageSearchBlock
        blockData={fields}
        cityName={cityName}
        service={service}
      />
    ))
  );
}

export default DynamicBlockContainer;

DynamicBlockContainer.propTypes = {
  blockType: PropTypes.string.isRequired,
  cityName: PropTypes.string,
  coordinates: PropTypes.shape({}),
  fields: PropTypes.shape({}),
  service: PropTypes.string,
};

DynamicBlockContainer.defaultProps = {
  cityName: "",
  coordinates: {
    lat: 41.8502,
    lon: -87.6736,
  },
  fields: {},
  service: undefined,
};
